import {isolarAnalyticsSimpleData} from './isolarAnalyticsSimpleData';

export class solarAnalyticsSimpleData {
 mySimpleData: isolarAnalyticsSimpleData[];

 constructor(data: isolarAnalyticsSimpleData[]) {
   this.mySimpleData = data;
 }

 getOne(num: number): isolarAnalyticsSimpleData{
   return this.mySimpleData[num];
 }

 getFirst(): isolarAnalyticsSimpleData{
   return this.mySimpleData[0];
 }

 getFirstDay(): string{
   return this.getFirst().t_stamp;
 }

 getDay(num: number): string{
    return this.getOne(num).t_stamp;
  }

  getGeneratedDataOne(num: number): number{
    return this.getOne(num).energy_generated;
  }

  getConsumedDataOne(num: number): number{
    return this.getOne(num).energy_consumed;
  }

 toString(num:number){
   // this.logger.log.debug(this.getOne(num).energy_expected);
 }

 getSize(): number {
   return this.mySimpleData.length;
 }

 getAll(): isolarAnalyticsSimpleData[]{
   return this.mySimpleData;
 }

 getDays(): string[]{
   let dayData:string[] = [];
   for(let num in this.mySimpleData){
     // this.logger.log.debug(this.getDay(Number(num)));
    dayData.push(this.getDay(Number(num)));
   }
    return dayData;
  }

  getGeneratedData(): number[]{
    let generatedDataSet:number[] = [];
    for(let num in this.mySimpleData){
      // this.logger.log.debug(this.getDay(Number(num)));
      generatedDataSet.push(this.getGeneratedDataOne(Number(num)));
    }

    return generatedDataSet;
  }

  getConsumedData(): number[]{
    let consumedDataSet:number[] = [];
    for(let num in this.mySimpleData){
      // this.logger.log.debug(this.getDay(Number(num)));
      consumedDataSet.push(this.getConsumedDataOne(Number(num)));
    }

    return consumedDataSet;
  }
}



// WEBPACK FOOTER //
// ./src/model/meter/solarAnalyticsSimpleData.ts